import SocialAnalyticsDashboard from '@/components/social/SocialAnalyticsDashboard';
import SocialScheduleDashboard from '@/components/social/SocialScheduleDashboard';
import PageViewsDashboard from '@/components/social/facebook/PageViewsDashboard';

export default [
  {
    path: '/social/analytics',
    name: 'SocialAnalytics',
    meta: { requiresAuth: true, action: 'view', subject: 'analytics' },
    component: SocialAnalyticsDashboard,
  },
  {
    path: '/social/schedules',
    name: 'SocialSchedules',
    meta: { requiresAuth: true, action: 'view', subject: 'social' },
    component: SocialScheduleDashboard,
  },
  {
    path: '/social/facebook/pageViews',
    name: 'PageViewsDashboard',
    meta: { requiresAuth: true, action: 'view', subject: 'social' },
    component: PageViewsDashboard,
  },
];



// WEBPACK FOOTER //
// ./src/router/social.js